// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m61x","colBig":"styles_colBig__2NDdQ","colSmall":"styles_colSmall__JfkpB"};